import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';

const Button = styled.button`
    background-color: ${props => props.backgroundColor};
    border: none;
    bottom: ${props => props.bottomMobile};
    cursor: pointer;
    display: block;
    flex-direction: column;
    font-family: 'Red Hat Display', sans-serif;
    padding: 10px 6px;
    position: fixed;
    right: 0;
    width: 34px;
    z-index: 99999;
    &:focus {
        outline: none;
    }
    @media ${mediaQueries.md} {
        bottom: ${props => props.bottom};
    }
`;
const LabelText = styled.span`
    color: #fff;
    display: block;
    margin-left: -2px;
    margin-top: -50%;
    transform: rotate(-90deg) translate(-100%);
    transform-origin: top left;
    white-space: nowrap;
`;
const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 0;
    width: 21px;
    @media ${mediaQueries.md} {
        margin-top: 6px;
    }
`;

const FixedSideButton = ({ labelText, bottom, bottomMobile, highlight = false, icon, onClick }) => (
    <Button
        backgroundColor={highlight ? '#696465' : '#000'}
        bottom={bottom}
        bottomMobile={bottomMobile}
        onClick={onClick}
    >
        <span className="d-none d-md-table">
            <span style={styles.labelWrapperInner}>
                <LabelText>{labelText}</LabelText>
            </span>
        </span>

        <IconContainer style={styles.iconContainer}>{icon}</IconContainer>
    </Button>
);

const styles = {
    labelWrapperInner: {
        display: 'block',
        height: 0,
        padding: '50% 0',
    },
    labelText: {
        color: '#fff',
        display: 'block',
        marginLeft: '-2px',
        marginTop: '-50%',
        transform: 'rotate(-90deg) translate(-100%)',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
    },
};

FixedSideButton.propTypes = {
    bottom: PropTypes.string.isRequired,
    bottomMobile: PropTypes.string.isRequired,
    labelText: PropTypes.string,
    highlight: PropTypes.bool,
    icon: PropTypes.element,
    onClick: PropTypes.func,
};

export default FixedSideButton;
